// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".consecutive-widget__header{color:var(--text-color);font-size:18px;margin-top:20px;position:relative}.consecutive-widget__header .left-box .number,.consecutive-widget__header .right-box{background:var(--countdown-background);border-radius:var(--card-radius);color:var(--countdown-text-color)}.consecutive-widget__header.is-mobile{font-size:14px;margin-top:10px;padding:0 5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
